define( function() {

	// All support tests are defined in their respective modules.
	return {};
} );



//////////////////
// WEBPACK FOOTER
// /var/www/html/themes/base/node_modules/jquery/src/var/support.js
// module id = 13
// module chunks = 8